
/* eslint-disable */
    import {defineComponent, h, nextTick, reactive} from 'vue'
    import {useRoute, useRouter} from "vue-router";
    import  reportMsgUt from "@/util/reportMsg";
    import {useStore} from '@/store';
    import { Toast } from 'scvant';
    import {GetZQYReportViewModelFromJSON, GetZQYReportViewModelFromServe, GetVerifyEffectiveReport} from '@/service'

    let nameList = [
        'navigation',
        'HeadTip',
        'CarNameVin',
        // 'SwiperBanner',
        ['LoopCarVideo',
        'BaseInfo',
        // 'ConfigurationInfo',
        'Entrust',
        'CheckCont',
        'entrustQuery',
        'EcuCheck',
        'RemarksMsg',
        'detectMsg',
        'EnsureService',
        'ReminderText']
    ]
    let list: any[] = [];
    let components = {};
    nameList.forEach(item => {
        let comName = '';
        if (typeof item === 'string') {
            comName = item;
            if (!components[comName]) {
                const model = require(`./_components/${comName}.vue`)['default'];
                list.push(model)
                components[comName] = model
            }else {
                list.push(components[comName])
            }
        } else if (typeof item === 'object'){
            let child: any[] = [];
            item.forEach(name => {
                let childName = name;
                if (!components[childName]) {
                    const model = require(`./_components/${childName}.vue`)['default'];
                    child.push(model)
                    components[childName] = model
                }else {
                    child.push(components[childName])
                }
            });
            list.push(child);
        }
        console.log('list:', list);
        // if (!components[item]) {
        //     // eslint-disable-next-line @typescript-eslint/no-var-requires
        //     const model = require(`./_components/${item}.vue`)['default'];
        //     list.push(model)
        //     components[item] = model
        // } else {
        //     list.push(components[item])
        // }
    });
    interface State {
        reportMsg: object;
    }
    export default defineComponent({
        name: "h5_index",
        components,
        setup() {
            let state: State = reactive({
                reportMsg: {}
            })
            state.reportMsg = reportMsgUt;
            document.title= "中国汽研二手车检测评估报告";
            const {query} = useRoute();
            const router = useRouter();
            const {reportCode, templateCode, reportVersion, targetPage} = query;
            let store = useStore()
            if (targetPage === 'photo_mark') {
                let queryCopy = JSON.parse(JSON.stringify(query));
                delete(queryCopy.targetPage);
                sessionStorage.setItem('targetPage', 'photo_mark');
                console.log('queryCopy', queryCopy);
                router.replace({
                    path: '/tocZQY',
                    query: queryCopy
                })
            }
            // 直链接口
            // GetReportViewModelFromServe({reportCode, templateCode}).then((res: any) => {
            //     store.dispatch('saveDataInfo', res)
            // }).catch((err) => {
            //     // eslint-disable-next-line
            //     console.error(err)
            // })
            // 先尝试json文件
            Toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中...',
            });
            function setReportResultList (res) {
                const { isAccident, isFire, isWater, accidentFlag, newAccidentRule } = res;
                console.log('newAccidentRule:', newAccidentRule);
                let accidentSrc = require('../../assets/tocV4/accident_299.png');
                let minorAccidentSrc = require('../../assets/tocV4/minor_accident_299.png');
                let noAccidentSrc = require('../../assets/tocV4/no_accident_299.png');
                let fireSrc = require('../../assets/tocV4/fire_299.png');
                let noFireSrc = require('../../assets/tocV4/no_fire_299.png');
                let waterSrc = require('../../assets/tocV4/water_299.png');
                let noWaterSrc = require('../../assets/tocV4/no_water_299.png');
                if (!newAccidentRule) {
                    let normal = (accidentFlag === 0 || accidentFlag === 1 || !isAccident) && !isFire && !isWater;
                    store.dispatch('saveIsNormal', normal);
                    let resultList = [{
                        src: accidentSrc,
                        otherSrc: minorAccidentSrc,
                        baseSrc: noAccidentSrc,
                        name: accidentFlag === 2 ? '重大事故' : (accidentFlag === 1 ? '非重大事故' : '非事故'),
                        isErr: accidentFlag === 2 ? 1 : 0
                    },
                    {
                        src: fireSrc,
                        baseSrc: noFireSrc,
                        name: isFire ? '火烧' : '非火烧',
                        isErr: isFire
                    },
                    {
                        src: waterSrc,
                        baseSrc: noWaterSrc,
                        name: isWater ? '泡水' : '非泡水',
                        isErr: isWater
                    }];
                    store.dispatch('saveReportResultList', resultList);
                } else {
                    let normal = !isFire && !isWater && (accidentFlag === 0 || accidentFlag === 1);
                    store.dispatch('saveIsNormal', normal);
                    let resultList = [{
                        src: accidentSrc,
                        otherSrc: minorAccidentSrc,
                        baseSrc: noAccidentSrc,
                        name: accidentFlag === 2 ? '重大事故' : (accidentFlag === 1 ? '事故' : '非事故'),
                        isErr: accidentFlag === 2 ? 1 : (accidentFlag === 1 ? 2 : 0)
                    },
                    {
                        src: fireSrc,
                        baseSrc: noFireSrc,
                        name: isFire ? '火烧' : '非火烧',
                        isErr: isFire
                    },
                    {
                        src: waterSrc,
                        baseSrc: noWaterSrc,
                        name: isWater ? '泡水' : '非泡水',
                        isErr: isWater
                    }];
                    store.dispatch('saveReportResultList', resultList);
                }
            }
            GetZQYReportViewModelFromJSON({reportCode, reportVersion, templateCode}).then((res: any) => {
                store.dispatch('saveDataInfo', res)
                store.dispatch('saveReportDetectVersion', res.reportDetectVersion)
                // console.log('saveDataInfos:', res);
                setReportResultList(res);
                nextTick(() => {
                    window.scrollTo(0, store.state.pageScrollTop)
                    store.dispatch('savePageScrollTop', 0);
                });
                Toast.clear();
                let targetPage = sessionStorage.getItem('targetPage');
                sessionStorage.removeItem('targetPage');
                if (targetPage === 'photo_mark') {
                    let queryCopy = JSON.parse(JSON.stringify(query));
                    delete(queryCopy.targetPage);
                    router.replace({
                        path: '/tocZQY',
                        query: queryCopy
                    })
                    router.push({
                        path:'/tocZQYPhotoList',
                        query: {
                            photoCode: res.markPhotoList[0].photoIdStr,
                            group: 'mark',
                            templateCode: templateCode
                        }
                    })
                }
            }).catch((err) => {
                if (err.message.indexOf('404')) {
                    // json文件404了请求直连接口
                    Toast.loading({
                        duration: 0,
                        forbidClick: true,
                        message: '加载中...',
                    });
                    GetZQYReportViewModelFromServe({reportCode, templateCode, reportVersion}).then((res: any) => {
                        store.dispatch('saveDataInfo', res)
                        store.dispatch('saveReportDetectVersion', res.reportDetectVersion)
                        setReportResultList(res);
                        nextTick(() => {
                            window.scrollTo(0, store.state.pageScrollTop)
                            store.dispatch('savePageScrollTop', 0);
                        });
                        Toast.clear();
                        let targetPage = sessionStorage.getItem('targetPage');
                        sessionStorage.removeItem('targetPage');
                        if (targetPage === 'photo_mark') {
                            let queryCopy = JSON.parse(JSON.stringify(query));
                            delete(queryCopy.targetPage);
                            router.replace({
                                path: '/tocZQY',
                                query: queryCopy
                            })
                            router.push({
                                path:'/tocZQYPhotoList',
                                query: {
                                    photoCode: res.markPhotoList[0].photoIdStr,
                                    group: 'mark',
                                    templateCode: templateCode
                                }
                            })
                        }
                    }).catch((err) => {
                        console.error(err)
                    })
                } else {
                    console.error(err)
                }
            })
            return {
                state,
                store
            }
        },
        render() {
            let className='';
            if (this.state.reportMsg['RpZB']()) {
                className = 'toc_main__bg_color';
            } else if (this.state.reportMsg['RpCK']()) {
                className = 'toc_main__bg_color';
            } else {
                className = 'toc_main__bg_color';
            }
            let renderSecChildren = function (item) {
                let chi: any[] = [];
                item.forEach(childItem => {
                    chi.push(h(childItem, {}));
                });
                return chi;
            }
            let renderChildren = function() {
                let arr: any[] = [];
                list.forEach(item => {
                    if (Object.prototype.toString.call(item) === '[object Object]') {
                        arr.push(h(item, {}));
                    } else if (Object.prototype.toString.call(item) === '[object Array]') {
                        arr.push(h('div', {class: 'reportMainBox'}, renderSecChildren(item)));
                    }
                });
                console.log('arr:', arr);
                return arr;
            }
            return h('keep-alive',{include: ''}, [h('div', {class: className}, renderChildren())]);
        },
        // h(item, {}, index)
        // beforeUnmount() {
        //     this.store.dispatch('savePageScrollTop', 0)
        // },
        beforeRouteEnter(to, from, next) {
            const {reportCode, templateCode} = to.query;
            if (!templateCode) {
                to.query.templateCode = 'no_cert_report';
            }
            if(`${reportCode}`.indexOf('DE') > -1) {
                let isClose = true;
                GetVerifyEffectiveReport({reportCode}).then((res: any) => {
                    isClose = res;
                    if (!isClose) {
                        next('/deffectiveReport')
                    } else {
                        next();
                    }
                }).catch(() => {
                    next();
                });
            } else {
                next();
            }
        }
    });
